import {
  RXDB_INVESTIGATION_ACTIVITY_COLLECTION_NAME,
  type InvestigationActivity as RxInvestigationActivity,
} from "$global-providers/rxdb-provider/collections/investigation-activity";
import { useRxDBContext } from "$global-providers/rxdb-provider/provider";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useRxData } from "rxdb-hooks";
import RequestedBubble from "./requested-bubble";

const RequestedCountBubble: React.FC<{ patientId: string }> = ({
  patientId,
}) => {
  const {
    replicationState: {
      investigationActivity: { isPulling },
    },
  } = useRxDBContext();

  const { result: patientInvestigations, isFetching } =
    useRxData<RxInvestigationActivity>(
      RXDB_INVESTIGATION_ACTIVITY_COLLECTION_NAME,
      (collection) => {
        return collection.find({
          selector: {
            patientId: {
              $eq: patientId,
            },
          },
        });
      },
    );

  const requestedCount =
    isPulling || isFetching
      ? "-"
      : patientInvestigations.filter((investigation) => !investigation.outcome)
          .length;

  return (
    <RequestedBubble>
      <strong>
        {requestedCount}{" "}
        <FormattedMessage
          id="investigationActivity.requestedCount.requested"
          defaultMessage="Requested Investigations"
        />
      </strong>
    </RequestedBubble>
  );
};

export default React.memo(RequestedCountBubble);
